/* src/app/core/modules/shared/components/modal-preface/modal-preface.component.scss */
/*# sourceMappingURL=/avvera/dev/modal-preface.component.css.map */
